import { Icon } from '@chakra-ui/react';

const PCRentMyIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M17.35,19.35c0.64,0.55,1.26,1.11,1.91,1.65c0.15,0.13,0.36,0.19,0.55,0.25c0.52,0.17,1.04,0.15,1.56,0.03
		c0.23-0.05,0.38,0.07,0.39,0.31c0.01,0.63,0.03,1.25,0.03,1.88c0,0.11-0.1,0.26-0.19,0.31c-0.51,0.27-1.06,0.37-1.64,0.33
		c-1.19-0.08-2.17-0.58-3.03-1.38c-0.98-0.91-2-1.79-3-2.68c-0.04-0.03-0.08-0.06-0.16-0.12c0,0.12,0,0.19,0,0.27
		c0,1.08,0,2.15,0,3.23c0,0.3-0.11,0.41-0.42,0.42c-0.72,0-1.44,0-2.16,0c-0.32,0-0.42-0.1-0.42-0.43c0-3.27,0-6.54,0-9.81
		c0-0.2,0.06-0.32,0.23-0.42c0.38-0.24,0.75-0.49,1.12-0.74c0.11-0.07,0.19-0.07,0.3,0c0.38,0.26,0.76,0.51,1.14,0.75
		c0.15,0.1,0.21,0.21,0.21,0.39c0,1.08,0.01,2.15,0.01,3.23c0,0.19,0.05,0.29,0.26,0.3c1.08,0.09,2.13-0.04,3.08-0.6
		c1.25-0.74,1.94-1.86,2.11-3.29c0.22-1.83-0.91-4.08-3.4-4.62c-1.97-0.42-3.66,0.13-5.07,1.52c-0.43,0.42-0.78,0.91-1.15,1.38
		c-0.18,0.22-0.26,0.25-0.48,0.07c-0.59-0.47-1.17-0.94-1.76-1.42c-0.19-0.15-0.21-0.24-0.07-0.44c1.37-2,3.19-3.36,5.6-3.83
		c1.74-0.34,3.45-0.2,5.06,0.58c1.97,0.96,3.41,2.45,4.05,4.58c0.61,2.03,0.18,3.91-1.02,5.63c-0.85,1.23-1.99,2.06-3.41,2.52
		c-0.05,0.02-0.11,0.04-0.16,0.06C17.37,19.3,17.36,19.33,17.35,19.35z"/>
			<path class="st0" d="M26.27,28.97H3.73c-1.49,0-2.7-1.21-2.7-2.7V3.73c0-1.49,1.21-2.7,2.7-2.7h22.54c1.49,0,2.7,1.21,2.7,2.7
		v22.54C28.97,27.76,27.76,28.97,26.27,28.97z M3.73,1.63c-1.16,0-2.1,0.94-2.1,2.1v22.54c0,1.16,0.94,2.1,2.1,2.1h22.54
		c1.16,0,2.1-0.94,2.1-2.1V3.73c0-1.16-0.94-2.1-2.1-2.1H3.73z"/>
		</g>

	</Icon>
);

export default PCRentMyIcon;
